'use client'

import { initAnalytics } from '@/lib/analytics'

void initAnalytics()
